import { FiltersPostData } from './typing/product-types.js'
import { FAKE, REAL, registerDependency } from '@cloudsuite/mosaic-shared/scripts/dependency-injection.js'

export interface VariantFilterApi {
  checkForRedirectOrNewFilterOptions(request: CheckForNewOptionsRequest): Promise<unknown>

  fetchAttributes(request: FetchAttributesRequest): Promise<unknown>
}

export interface FakeVariantFilterApiInterface extends VariantFilterApi {
  url: string,
  data: FiltersPostData,
  fetchAttributesData: unknown
}

export class CheckForNewOptionsRequest {
  endpointUrl: URL
  method = 'POST' as const
  headers: HeadersInit = { 'Content-Type': 'application/json' }
  controller: AbortController = new AbortController()
  body: FiltersPostData

  constructor(endpoint: string, data: FiltersPostData) {
    this.endpointUrl = new URL(endpoint, window.location.href)
    this.body = data
  }
}

export class FetchAttributesRequest {
  endpointUrl: URL
  method = 'GET' as const
  headers: HeadersInit = { Accept: 'application/json' }

  constructor(endpoint: string) {
    this.endpointUrl = new URL(endpoint, window.location.href)
  }
}

export const VARIANT_FILTER_API = Symbol('VARIANT_FILTER_API')

@registerDependency(FAKE, VARIANT_FILTER_API)
export class FakeVariantFilterApi implements FakeVariantFilterApiInterface {
  url: string = ''
  data: FiltersPostData = {
    attribute: '',
    filters: {},
    value: '',
  }
  filterAttributesResponses: {[key: string]: unknown} = {}
  fetchAttributesData: unknown
  requests: Array<CheckForNewOptionsRequest | FetchAttributesRequest> = []

  checkForRedirectOrNewFilterOptions(request: CheckForNewOptionsRequest): Promise<unknown> {
    this.url = request.endpointUrl.toString()
    this.data = request.body
    this.requests.push(request)

    return Promise.resolve(this.filterAttributesResponses[JSON.stringify(this.data.filters)])
  }

  fetchAttributes(request: FetchAttributesRequest): Promise<unknown> {
    this.requests.push(request)
    return Promise.resolve(this.fetchAttributesData)
  }
}

const parseJsonResponse = async (response: Response): Promise<unknown> => {
  if (!response.ok) {
    throw new Error(`Variant filter request failed with status ${response.status}`)
  }

  return await response.json()
}

@registerDependency(REAL, VARIANT_FILTER_API)
export class ProductionVariantApi implements VariantFilterApi {
  async checkForRedirectOrNewFilterOptions(request: CheckForNewOptionsRequest): Promise<unknown> {
    const response: Response = await fetch(request.endpointUrl, {
      method: request.method,
      headers: request.headers,
      signal: request.controller.signal,
      body: JSON.stringify(request.body),
    })
    return await parseJsonResponse(response)
  }

  async fetchAttributes(request: FetchAttributesRequest): Promise<unknown> {
    const response: Response = await fetch(request.endpointUrl, {
      headers: request.headers,
      method: request.method,
    })
    return await parseJsonResponse(response)
  }
}
